import { afterNextRender, Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';
import { DesktopModeService } from '@core/desktop/desktop-mode.service';
import { HomeBottomMenuComponent } from '@components/home-bottom-menu/home-bottom-menu.component';
import { LoadingAppComponent } from '@shared/components/loading-app/loading-app.component';
import { LastVisitedCompanyService } from '@shared/services/last-visited-company.service';

@Component({
  selector: 'agj-home',
  imports: [RouterOutlet, LoadingAppComponent, HomeBottomMenuComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  private router = inject(Router);
  private authService = inject(AuthService);
  private lastVisitedCompany = inject(LastVisitedCompanyService);
  // Desktop: a barra de navegação do topo (home-bottom-menu) só existe nele
  public desktopMode = inject(DesktopModeService);

  constructor() {
    afterNextRender(() => {
      const path = this.router.url.split('?')[0];
      if (path !== '/agendamentos' && path !== '/meu-perfil') return;
      if (!this.authService.authenticated) return;

      this.lastVisitedCompany.resolve().subscribe((slug) => {
        if (!slug) return;

        void this.router.navigateByUrl(
          this.lastVisitedCompany.euUrlTree(this.router, slug, path === '/agendamentos' ? 'agendamentos' : undefined),
          { replaceUrl: true }
        );
      });
    });
  }
}
